var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.61 151.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eee;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BlackPearl-Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.34,137.88H92.27c5.57,0,5.57-8.68,0-8.68H59.34c-5.57,0-5.57,8.68,0,8.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.54,151.15H90.07c5.57,0,5.57-8.68,0-8.68H61.54c-5.57,0-5.57,8.68,0,8.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,9.23,73.93,51.14A3,3,0,1,0,78,55.45h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.31,43A32.39,32.39,0,0,1,63.16,23.8l-1.9-5.17A37.8,37.8,0,0,0,40,41.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.41,46.21,39.12,44.7a37.69,37.69,0,0,0,1.32,21.85l5.15-1.91a32.09,32.09,0,0,1-1.18-18.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.7,24.88,95,21a37.66,37.66,0,0,0-30.67-3.5l1.9,5.16A32.12,32.12,0,0,1,90.7,24.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.47,22.53,113,28.68a42.34,42.34,0,0,1-5.71,54.11,58.09,58.09,0,0,0-17.12,33.9H61.67a58,58,0,0,0-17.13-33.9,42.61,42.61,0,0,1,0-61.15A44.32,44.32,0,0,1,75.82,8.88a45.58,45.58,0,0,1,24.6,7.25l6-5.41a53.15,53.15,0,0,0-67.65,5.33,50.32,50.32,0,0,0,0,72.33,49.39,49.39,0,0,1,14.85,29.88c.35,2.1,2.62,6.29,6.64,6.29H91c4,0,6.47-4.19,6.64-6.29a50.88,50.88,0,0,1,14.85-29.88A49.9,49.9,0,0,0,118.47,22.53Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightInsights);
export default __webpack_public_path__ + "static/media/light-insights.b480239a14877f34479f3c3fde2ed436.svg";
export { ForwardRef as ReactComponent };